import { render, staticRenderFns } from "./LocaleSettings.vue?vue&type=template&id=001c2709&"
import script from "./LocaleSettings.vue?vue&type=script&lang=ts&"
export * from "./LocaleSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports